import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Button, Text } from 'components/base'
import { selectors as AuthSelectors } from 'data/auth'
import { selectors as ConfigSelectors } from 'data/config'
import { selectors as OrganizationsSelectors } from 'data/organizations'
import IncentiveBox from 'components/Utils/IncentiveBox'
import OpenID from './OpenID'

class Google extends Component {
  renderConnect() {}

  renderConfigureItem({ index, text }) {
    return (
      <div className="flexbox flexbox-centered shade-10 font-size-large margin-bottom-small line-height-larger">
        <div className="flexbox-no-grow margin-right-medium">
          <div
            className="radius-round border-solid border-small border-shade-40 font-weight-medium flexbox flexbox-centered"
            style={{ width: 28, height: 28 }}
          >
            {index}
          </div>
        </div>
        <div className="flexbox-grow">{text}</div>
      </div>
    )
  }

  onEnable = event => {
    event.preventDefault()
    this.props.onEnable()
  }

  render() {
    const { organization, apiEndpoint, apiToken, hasOpenIDFlag } = this.props
    const organizationName = organization.get('name')
    return (
      <div className="margin-bottom-larger">
        <div className="flexbox flexbox-column">
          <div className="flexbox-grow">
            <Text.Title className="line-height-largest">
              SSO authentication
            </Text.Title>
            <div className="flexbox shade-10 font-size-large line-height-larger">
              Single Sign-On (SSO) allows your team to sign in with their SSO
              account. <br />
              As an admin, you can activate or switch back to standard password
              authentication anytime.
            </div>
            <div className="margin-top-large">
              <Text.Subtitle className="margin-bottom-medium">
                How does it help my team?
              </Text.Subtitle>
              {this.renderConfigureItem({
                index: 1,
                text: (
                  <span>
                    No need to remember your email and password, your team can
                    sign in using their centralized account.
                  </span>
                ),
              })}
              {this.renderConfigureItem({
                index: 2,
                text: (
                  <span>
                    Admins can still sign in to{' '}
                    <span className="font-weight-medium">
                      {organizationName}
                    </span>{' '}
                    using their current email and password.
                  </span>
                ),
              })}
              {this.renderConfigureItem({
                index: 3,
                text: (
                  <span>
                    It's compatible with auto join and auth domains (see team
                    settings tab).
                  </span>
                ),
              })}
            </div>
            <div className="flexbox flexbox-no-grow">
              <IncentiveBox
                className="margin-top-medium"
                incentiveId="googleSSO"
              />
            </div>
            <div className="flexbox flexbox-align-center margin-top-large">
              {!this.props.isFree && (
                <Button.Primary
                  onClick={() => {
                    window.location = `${apiEndpoint}/auth/google/setup?apiToken=${apiToken}`
                  }}
                >
                  Enable Google SSO
                </Button.Primary>
              )}
            </div>
            {hasOpenIDFlag && !this.props.isFree && <OpenID />}
          </div>
        </div>
      </div>
    )
  }
}

export default connect(state => ({
  apiEndpoint: ConfigSelectors.getApiEndpoint(state),
  apiToken: AuthSelectors.getAuthTokens(state).apiToken,
  hasOpenIDFlag: OrganizationsSelectors.hasFeatureFlag(state, 'openid'),
}))(Google)
